var map = {
	"./Step1.svg": 1065,
	"./Step2.svg": 1066,
	"./Step3.svg": 1067,
	"./calendar_1week.svg": 1560,
	"./calendar_2weeks.svg": 1561,
	"./calendar_date.svg": 1562,
	"./calendar_hour.svg": 1563,
	"./calendar_month.svg": 1564,
	"./calendar_question.svg": 1565,
	"./continue_brief.svg": 1061,
	"./copy_brief.svg": 1060,
	"./new_brief.svg": 1062,
	"./partners/nationbuilder.png": 1079
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1559;